"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasUserEvents = exports.useUserEvents = exports.useUserEventsOnFeed = void 0;
var usePaginatedModel_1 = __importDefault(require("./usePaginatedModel"));
var react_1 = require("react");
var hooks_1 = require("../util/hooks");
var useCurrentUser_1 = __importDefault(require("./useCurrentUser"));
var useUserEventsOnFeed = function () {
    var isNarrow = (0, hooks_1.useBreakpoint)('md');
    var now = (0, react_1.useState)(new Date())[0];
    var data = (0, exports.useUserEvents)({
        'start_date[gte]': now.toISOString(),
        canceled_at: 'null',
        limit: isNarrow ? 1 : 3,
        order_by: 'start_date',
    }).data;
    return data;
};
exports.useUserEventsOnFeed = useUserEventsOnFeed;
var useUserEvents = function (filters) {
    var user = (0, useCurrentUser_1.default)().data;
    return (0, usePaginatedModel_1.default)("users/".concat(user === null || user === void 0 ? void 0 : user.id, "/experiences"), filters, { requiresAuth: true, queryConfig: { enabled: !!(user === null || user === void 0 ? void 0 : user.id) } });
};
exports.useUserEvents = useUserEvents;
var useHasUserEvents = function () {
    var data = (0, exports.useUserEvents)({
        limit: 1,
    }).data;
    if (!data) {
        return undefined;
    }
    return !!data.results.length;
};
exports.useHasUserEvents = useHasUserEvents;
exports.default = exports.useUserEvents;
//# sourceMappingURL=useUserEvents.js.map